import { toast } from '@/shared/utils/UIHelper'
import AccountRepository from '@/shared/http/repositories/access/account'
import { mapActions } from 'vuex'
import SignInMixin from '@/store/module/signIn/mixin'
import { globalActions as authActions } from '@/store/module/auth/actionTypes'

export default {
  name: 'ChangePassword',
  mixins: [
    SignInMixin
  ],
  data () {
    return {
      version: process.env.VersionApp,
      token: null,
      password: null,
      confirmation: null,
      link: null,
      randomImage: '',
      images: [
        'https://static.zopone.com.br/img/login1.jpg',
        'https://static.zopone.com.br/img/login2.jpg',
        'https://static.zopone.com.br/img/login3.jpg',
        'https://static.zopone.com.br/img/login4.jpg',
        'https://static.zopone.com.br/img/login5.jpg',
        'https://static.zopone.com.br/img/login6.jpg',
        'https://static.zopone.com.br/img/login7.jpg',
        'https://static.zopone.com.br/img/login8.jpg',
        'https://static.zopone.com.br/img/login9.jpg',
        'https://static.zopone.com.br/img/login10.jpg',
        'https://static.zopone.com.br/img/login11.jpg'
      ]
    }
  },
  mounted () {
    this.token = this.$route.params.token
    const idx = Math.floor(Math.random() * this.images.length)
    this.randomImage = `url("${this.images[idx]}")`
  },
  methods: {
    ...mapActions({
      signIn: authActions.SIGN_IN,
      fetchUserInfo: authActions.FETCH_USER_INFO
    }),
    onResetPassword () {
      if (this.password.length < 6) {
        toast.error('Senha deve conter no mínimo 6 caractéres!')
      } else {
        let resetSenha = {Token: this.token, Senha: this.password}
        AccountRepository.ResetSenhaZpag(resetSenha)
          .then(Response => {
            toast.success('Senha alterada com sucesso!')
          })
          .catch(error => {
            // Set toast
            toast.error(error.response.data)
            console.log(error)
          })
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/public/password/changeZpag/changeZpag.js